<template>
    <ItemMenuWrapper :label="label" :tooltip="tooltip" v-slot="{ inputId }">
        <InputNumber :id="inputId" v-model="value" :min="min" :max="max" @update:modelValue="handleUpdate" class="w-full" />
    </ItemMenuWrapper>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { defineProps, defineEmits, ref, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: Number,
        default: 0,
    },
    label: {
        type: String,
        required: true,
    },
    min: {
        type: Number,
        default: 0,
    },
    max: {
        type: Number,
        default: 9999,
    },
    tooltip: {
        type: String,
        default: null,
    },
});

const emit = defineEmits(['update:modelValue']);
const value = ref(props.modelValue);

watch(
    () => props.modelValue,
    (newVal) => {
        value.value = newVal;
    },
    { immediate: true }
);

const handleUpdate = () => {
    emit('update:modelValue', value.value);
};
</script>
